<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
        d="M1 7.5C1 11.0899 3.91015 14 7.5 14C11.0899 14 14 11.0899 14 7.5C14 3.91015 11.0899 1 7.5 1C3.91015 1 1 3.91015 1 7.5Z"
        stroke="var(--icon-color)" />
    <rect x="4" y="7" width="7" height="1" rx="0.5" fill="var(--icon-color)" />
    <path
        d="M7.5 4C7.77614 4 8 4.22386 8 4.5L8 10.5C8 10.7761 7.77614 11 7.5 11V11C7.22386 11 7 10.7761 7 10.5L7 4.5C7 4.22386 7.22386 4 7.5 4V4Z"
        fill="var(--icon-color)" />
</svg>

